'use client';

import { useTheme } from 'next-themes';
import { Sun, Moon } from 'lucide-react';
import { useEffect, useState } from 'react';

export function ThemeSwitcher() {
  // resolvedTheme, а не theme: пока человек ничего не выбирал, theme равна
  // 'system', и по ней нельзя понять, какую тему он сейчас видит.
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return <div className="w-9 h-9" />;

  return (
    <button
      onClick={() => {
        setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
      }}
      className="w-9 h-9 flex items-center justify-center rounded-lg border border-[var(--color-border)] hover:border-[var(--color-text-muted)] transition-colors cursor-pointer"
      aria-label="Toggle theme"
    >
      {resolvedTheme === 'dark' ? (
        <Sun className="w-4 h-4 text-[var(--color-text)]" />
      ) : (
        <Moon className="w-4 h-4 text-[var(--color-text)]" />
      )}
    </button>
  );
}
